import { useEffect } from 'react'
import { useEditorStore, type SectionState } from '../store/editor.store'
import { sitesApi, projectsApi } from '../utils/api'

export function usePageLazyLoad() {
  const activePageId = useEditorStore(s => s.activePageId)
  const loadedPageIds = useEditorStore(s => s.loadedPageIds)
  const setPageContent = useEditorStore(s => s.setPageContent)

  useEffect(() => {
    if (!activePageId || loadedPageIds.includes(activePageId)) return
    // Local pages (bst- prefix) don't exist on the server yet — nothing to load
    if (activePageId.startsWith('bst-')) return

    const projectId = localStorage.getItem('bst-project-id')
    const siteId = localStorage.getItem('bst-site-id')

    let cancelled = false

    const onContent = (sections: SectionState[]) => {
      if (!cancelled) setPageContent(activePageId, sections)
    }
    const onError = () => {
      if (!cancelled) setPageContent(activePageId, [])
    }

    if (projectId) {
      projectsApi.getPage(projectId, activePageId)
        .then(p => onContent((p.content?.sections ?? []) as SectionState[]))
        .catch(onError)
    } else if (siteId) {
      sitesApi.getPageContent(siteId, activePageId)
        .then(p => onContent((p.content?.sections ?? []) as SectionState[]))
        .catch(onError)
    }

    return () => { cancelled = true }
  }, [activePageId, loadedPageIds, setPageContent])
}
